<template>
  <div class="courses-list">
    <CourseCard
      v-for="course in courses"
      :key="course.id"
      :course="course"
      @select-course="selectCourse"
    />
  </div>
</template>

<script>
import CourseCard from "./CourseCard.vue";

export default {
  name: "CoursesList",
  components: { CourseCard },
  props: {
    courses: {
      type: Array,
      required: true,
    },
  },
  methods: {
    /**
     * selected course based on its id
     * @param id number
     * @param exists boolean
     */
    selectCourse(id, exists) {
      if (!exists) {
        return this.$store.dispatch("saveSelectedCourse", id);
      }
      this.$store.dispatch("removeSelectedCourse", id);
    },
  },
};
</script>

<style lang="scss" scoped>
.courses-list {
  display: grid;
  grid-template-columns: repeat(3, 33%);
  column-gap: 9px;
  row-gap: 16px;
}

@media all and (max-width: $max-md-screen) and (min-width: $min-md-screen) {
  .courses-list {
    grid-template-columns: repeat(2, 1fr);
    column-gap: 24px;
  }
}

@media all and (max-width: $min-md-screen) {
  .courses-list {
    grid-template-columns: repeat(2, 1fr);
    column-gap: 7px;
  }
}
</style>
